// extracted by mini-css-extract-plugin
export var button = "subscriptionForm-modules--button--5HH3a";
export var textInput = "subscriptionForm-modules--textInput--1JDbI";
export var textInputContainsError = "subscriptionForm-modules--textInputContainsError--2fxjD";